import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DropFitnessSDKService } from './dropfitnesssdk.service';
import { User } from '../models/auth.models';
import { AppSettings, StorageKey } from '../appsettings';

@Injectable({ providedIn: 'root' })

/**
 * Auth-service Component
 */
export class AuthenticationService {

    userAvatar: string = 'assets/images/users/user-dummy-img.jpg';

    constructor(private http: HttpClient, private dfservice: DropFitnessSDKService) {
    }

    /**
     * Performs the register
     * @param email email
     * @param password password
     */
    register(email: string, password: string) {
        return this.dfservice.registerUser(email, password);
        // return getDropfitnessBackend()!.registerUser(email, password).then((response: any) => {
        //     const user = response;
        //     return user;
        // });
    }

    /**
     * Performs the auth
     * @param email email of user
     * @param password password of user
     * @param rememberme remember me flag
     * @param facilityId facility which is being used by the user
     */
    login(email: string, password: string, rememberme: boolean, facilityId: number) {
        return this.dfservice.loginUser(email, password, facilityId).then((response: any) => {
            const user = response;
            if (user && user.Token) {
                if (rememberme) {
                    sessionStorage.removeItem(StorageKey.AUTH_USER);
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem(StorageKey.AUTH_USER, JSON.stringify(user));
                } else {
                    localStorage.removeItem(StorageKey.AUTH_USER);
                    // store user details and jwt token in session storage. this clears once the session is over
                    sessionStorage.setItem(StorageKey.AUTH_USER, JSON.stringify(user));
                }
            }
            return user;
        }).catch((error) => {
            throw error;
        });
        // return getDropfitnessBackend()!.loginUser(email, password).then((response: any) => {
        //     const user = response;
        //     return user;
        // });
    }

    resetPassword(email: string) {
        return this.dfservice.resetPassword(email).then((response: any) => {
            return response;
        }).catch((error: any) => {
            return error;
        });
    }

    changePassword(oldPassword: string, password: string, confirmPassword: string) {
        let currentUser = this.currentAuthDetails();
        return this.dfservice.changePassword(currentUser.PersonId, oldPassword, password, confirmPassword).then((response: any) => {
            return true;
        }).catch((error: any) => {
            return error;
        });
    }

    /**
     * Returns the current user
     */
    public currentAuthDetails(): any {
        if (!localStorage.getItem(StorageKey.AUTH_USER) && !sessionStorage.getItem(StorageKey.AUTH_USER)) {
            return null;
        }
        return JSON.parse(localStorage.getItem(StorageKey.AUTH_USER)! || sessionStorage.getItem(StorageKey.AUTH_USER)!);
        // return getDropfitnessBackend()!.getAuthenticatedUser();
    }

    public currentUserDetails(): any {
        if (!localStorage.getItem(StorageKey.CURRENT_USER)) {
            return null;
        }
        return JSON.parse(localStorage.getItem(StorageKey.CURRENT_USER)! || sessionStorage.getItem(StorageKey.CURRENT_USER)!);
        // return getDropfitnessBackend()!.getAuthenticatedUser();
    }

    /**
     * Logout the user
     */
    logout() {
        localStorage.removeItem(StorageKey.AUTH_USER);
        sessionStorage.removeItem(StorageKey.AUTH_USER);
        localStorage.removeItem(StorageKey.CURRENT_USER);

        // logout the user
        return this.dfservice.logout();
        // return getDropfitnessBackend()!.logout();
    }

    getUserAvatar() {
        return this.userAvatar;
    }

    setUserAvatar(avatar: string) {
        this.userAvatar = avatar;
    }

}

